import {
  Button
} from "melco-ui";
import { useTranslation } from "react-i18next";

import { Drawer as DrawerType } from "../../hooks/drawer/useGenericDrawer";

type UserProductsButtonProps = {
  referencesDrawer: DrawerType;

};

export const UserProductsButton: React.FC<
  UserProductsButtonProps
> = ({ referencesDrawer }) => {
  const { t } = useTranslation();



  return (

    <Button
      key="color-collection-duplicate"
      type="primary"
      onClick={async () => {
        referencesDrawer.openDrawer();
      }}

    >
      {t('users.products.button')}

    </Button>


  );
};
